import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveUserMutation = gql`
   mutation SaveUser(
      $user: UserPostInput!
      $userPrivileges: [UserPrivilegeInput!]!
      $deletedUserRoleIds: [UInt!]!
      $deletedUserReportIds: [UInt!]!
      $deletedUserPrivilegeIds: [UInt!]!
      $deletedUserCallRecordingExtensionIds: [UInt!]!
      $deletedUserCallRecordingExtensionGroupIds: [UInt!]!
      $hasDeletedUserRoles: Boolean = false
      $hasDeletedUserReports: Boolean = false
      $hasDeletedUserPrivileges: Boolean = false
      $hasDeletedCallRecordingExtensions: Boolean = false
      $hasDeletedCallRecordingExtensionGroups: Boolean = false
   ) {
      deleteUserRoles(ids: $deletedUserRoleIds) @include(if: $hasDeletedUserRoles)
      deleteUserReports(ids: $deletedUserReportIds) @include(if: $hasDeletedUserReports)
      deleteUserPrivileges(ids: $deletedUserPrivilegeIds) @include(if: $hasDeletedUserPrivileges)
      deleteUserCallRecordingExtensions(ids: $deletedUserCallRecordingExtensionIds)
         @include(if: $hasDeletedCallRecordingExtensions)
      deleteUserCallRecordingExtensionGroups(ids: $deletedUserCallRecordingExtensionGroupIds)
         @include(if: $hasDeletedCallRecordingExtensionGroups)
      user: saveUser(user: $user) {
         userId
         username
         name
         emailAddress
         isSystemUser
         account {
            accountId
            name
            isSuspended
         }
         rolesConnection {
            items {
               userRoleId
               userId
               roleId
            }
         }
         userReportsConnection {
            items {
               userId
               reportId
            }
         }
         userCallRecordingExtensionsConnection {
            items {
               userCallRecordingExtensionId
               userId
               extensionId
               isInclude
            }
         }
         userCallRecordingExtensionGroupsConnection {
            items {
               userCallRecordingExtensionGroupId
               userId
               extensionGroupId
               isInclude
            }
         }
         hasAllExtensionRecordings
         extensionId
         isActive
         isLocked
         lockoutDate
         isForcePasswordChange
         failedLoginAttempts
         lastPasswordChangeDate
         isAdmin
         createDate
         createUser {
            userId
            name
         }
         updateDate
         updateUser {
            userId
            name
         }
      }
      userPrivileges: saveUserPrivileges(userPrivileges: $userPrivileges) {
         userPrivilegeId
         privilegeId
         userId
         accountId
         isAdd
         isView
         isEdit
         isDelete
         isEnabled
      }
   }
`;
